import { Download } from "lucide-react";
import { GOALS } from "./marketing-data";

const CARD_CLASSES = "flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-card";

const CardBody = ({ document, section, children }) => (
    <div className="flex flex-1 flex-col gap-1.5 p-4">
        <p className={`text-[11px] font-bold uppercase tracking-[0.12em] ${section.eyebrowClass}`}>{section.eyebrow ?? section.label}</p>
        <h3 className="text-[15px] font-bold leading-snug text-gray-900 break-words">{document.title}</h3>
        <p className="text-sm leading-relaxed text-gray-600">{document.description}</p>
        <div className="mt-0.5 flex flex-wrap gap-1.5">
            {document.goals.map((g) => (
                <span key={g} className="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700">
                    {GOALS[g]}
                </span>
            ))}
        </div>
        <div className="mt-auto pt-3">{children}</div>
    </div>
);

const Thumbnail = ({ src, children }) => (
    <div className="relative h-[160px] overflow-hidden bg-gray-100">
        <img src={src} alt="" className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105" />
        {children}
    </div>
);

export const DocumentCard = ({ document, section }) => (
    <article className={CARD_CLASSES}>
        <a
            href={document.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open ${document.title}`}
            className="group block"
        >
            <Thumbnail src={document.thumbnail} />
        </a>
        <CardBody document={document} section={section}>
            <a
                href={document.href}
                download
                aria-label={`Download ${document.title}`}
                className="inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-lg border border-primary text-sm font-semibold text-primary-darker no-underline transition-colors hover:bg-primary hover:text-white"
            >
                <Download className="h-4 w-4" aria-hidden="true" />
                Download
            </a>
        </CardBody>
    </article>
);

export const FamilyCard = ({ document, section, catalog, onOpen }) => {
    const storyId = catalog.resolveStory(undefined, catalog.defaultRegion);
    const preview = catalog.fileFor(storyId, catalog.defaultRegion);

    return (
        <article className={CARD_CLASSES}>
            <button
                type="button"
                onClick={onOpen}
                aria-label={`Open ${document.title}`}
                className="group block w-full text-left"
            >
                <Thumbnail src={preview.thumbnail}>
                    <span className="absolute left-2.5 top-2.5 rounded-full bg-[#082e54] px-2 py-0.5 text-[11px] font-bold tracking-[0.06em] text-white">
                        {catalog.badge}
                    </span>
                </Thumbnail>
            </button>
            <CardBody document={document} section={section}>
                <button
                    type="button"
                    onClick={onOpen}
                    className="min-h-[44px] w-full rounded-lg bg-primary text-sm font-semibold text-[#fff] transition-colors hover:bg-primary-dark"
                >
                    Choose a version
                </button>
            </CardBody>
        </article>
    );
};
